import angular from 'angular';
import angularRoute from 'angular-route';

import LogoutCtrl from './logout-ctrl';
import routes from './logout-routes';

export default angular.module('logout', [angularRoute])
    .controller('LogoutCtrl', LogoutCtrl)
    .config(routes)
    .name;



// WEBPACK FOOTER //
// ./logout/logout-module.js